import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import FormSearch from "./forms/FormSearch";
import { LucideBoxes, Search, SearchX } from "lucide-react";
import { apiSend, getRoute } from "@services/axios";
import { Col, Row, Table, Pagination, Spinner, Button } from "react-bootstrap";
import { dateFrEn, money } from "@global/actions";
import { Eye } from "lucide-react";
import Details from "./Details";
import { useModal } from "@components/ModalContext";
import { Config } from "@config/config";
import ManageHeader from "@components/ManageHeader";

// React Icons imports for calendar, info, and pagination
import { 
  FaCalendarAlt, FaInfoCircle, FaChevronLeft, FaChevronRight
} from "react-icons/fa";

const Home = (props) => {
  const { t } = useTranslation();
  const config = new Config(t);
  const { openModal, setFullscreen, setTitle, setModalBodyClass } = useModal();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState(null);
  const [selectProduct, setSelectProduct] = useState(null);
  const [bookingsList, setBookingsList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState(
    new Date().toLocaleDateString("fr-FR")
  );
  const [dateTo, setDateTo] = useState(new Date().toLocaleDateString("fr-FR"));
  const [activeFormSearch, setActiveFormSearch] = useState("d-none");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const displaySearch = () => {
    setActiveFormSearch(activeFormSearch === "d-none" ? "" : "d-none");
  };

  const loadData = async (page) => {
    setLoading(true);
    setCurrentPage(page);

    const payload = {
      product_id: selectProduct?.value ? selectProduct?.value : "",
      service: selectedService?.value ? selectedService?.value : "",
      status: selectedStatus?.value ? selectedService?.value : "",
      payment_status: selectedPayment?.value ? selectedPayment?.value : "",
      country_code: selectedCountryCode?.value
        ? selectedCountryCode?.value
        : "",
      dateFrom: dateFrEn(dateFrom),
      dateTo: dateFrEn(dateTo),
      dateType: selectedDate?.value ? selectedDate?.value : "",
    };

    const response = await apiSend(
      getRoute("booking") + "?page=" + page,
      "post",
      payload
    );

    if (response?.data?.result?.total > 0) {
      setBookingsList(response?.data?.result.data);
      setTotal(response?.data?.result?.total);
    } else {
      setBookingsList([]);
      setTotal(0);
    }
    setLoading(false);
  };

  useEffect(() => {
    const timerId = setTimeout(async () => {
      await loadData(1);
    }, 200);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  const handlePageChange = (page) => {
    loadData(page);
  };
  const [maxVisiblePages, setMaxVisiblePages] = useState(5);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 576) {
        setMaxVisiblePages(2); // mobile
      } else if (window.innerWidth < 768) {
        setMaxVisiblePages(3); // tablet
      } else {
        setMaxVisiblePages(5); // desktop
      }
    };

    handleResize(); // run on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleSeeClick = async (item) => {
    setFullscreen(true);
    setModalBodyClass('bg-light');
    setTitle("N° : " + item.bookingNumber);
    openModal(<Details bookingNumber={item.bookingNumber} />);
  };

  const totalPages = Math.ceil(total / pageSize);

  const getStatusClass = (status) => {
    const statusMap = {
      'confirmed': 'status-confirmed',
      'pending': 'status-pending',
      'cancelled': 'status-cancelled',
      'completed': 'status-completed',
      'refunded': 'status-cancelled',
      'unpaid': 'status-pending'
    };
    return statusMap[status?.toLowerCase()] || 'status-pending';
  };

  return (
    <>
      <div className="table-container p-4 bg-white rounded-4 shadow">
        {/* <ManageHeader
          title={t("")}
          content={t("overview_bookings")}
          icon={<LucideBoxes size={25} strokeWidth={1.5} className="text-blue" />}
        /> */}
        
   

        <div className={`py-4 border-0 mb-4 box-shadow rounded-4 bg-white `}>
          <FormSearch
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            selectedService={selectedService}
            setSelectedService={setSelectedService}
            selectedPayment={selectedPayment}
            setSelectedPayment={setSelectedPayment}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            selectedCountryCode={selectedCountryCode}
            setSelectedCountryCode={setSelectedCountryCode}
            selectProduct={selectProduct}
            setSelectProduct={setSelectProduct}
            loadData={loadData}
            dateFrom={dateFrom}
            setDateFrom={setDateFrom}
            dateTo={dateTo}
            setDateTo={setDateTo}
          />
        </div>

        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" variant="primary" className="text-blue" />
          </div>
        ) : (
          <>
            <div className=" rounded-3 border-0" >
              <div className="table-responsive-custom"></div>
              <Table className="table booking-table mb-0 align-middle">
                <thead className="bg-blue">
                  <tr>
                    <th className="text-start">N°</th>
                    <th className="text-start d-none d-lg-table-cell">{t("holder")}</th>
                    <th className="text-center d-none d-xl-table-cell">{t("check_in")}</th>
                    <th className="text-center d-none d-xl-table-cell">{t("check_out")}</th>
                    <th className="text-center d-none d-md-table-cell">{t("status")}</th>
                    <th className="text-end d-none d-xl-table-cell">{t("price")}</th>
                    {/* <th className="text-center d-none d-xl-table-cell">{t("currency")}</th> */}
                    <th className="text-center">{("action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {bookingsList.map((row, index) => (
                    <tr key={index} className="booking-row">
                      <td>
                        <div className="booking-number">
                          <span className="service-icon">
                            {config.serviceIcon(row.service)}
                          </span>
                          <span className="fw-semibold text-dark">{row.bookingNumber}</span>
                        </div>
                      </td>
                      <td className="fw-medium text-dark d-none d-lg-table-cell">{row.holder}</td>
                      <td className="text-center d-none d-xl-table-cell">
                        <span className="text-secondary d-inline-flex align-items-center gap-2 d-none d-xl-table-cell">
                          <FaCalendarAlt className="text-blue" size={14} />
                          {row.checkin}
                        </span>
                      </td>
                      <td className="text-center d-none d-xl-table-cell">
                        <span className="text-secondary d-inline-flex align-items-center gap-2">
                          <FaCalendarAlt className="text-blue" size={14} />
                          {row.checkout}
                        </span>
                      </td>
                      <td className="text-center d-none d-md-table-cell">
                        <span className={`status-badge ${getStatusClass(row.status)}`}>
                          {row.status}
                        </span>
                      </td>
                      <td className="text-end d-none d-xl-table-cell">
                        <span className="price">
                          {money(row.amountTotal)} {row.currency}
                        </span>
                      </td>
                      {/* <td className="text-center d-none d-xl-table-cell">
                        <span className="currency badge bg-light text-dark px-3 py-2 rounded-pill">
                          {row.currency}
                        </span>
                      </td> */}
                      <td className="text-center">
                        <button 
                          onClick={() => handleSeeClick(row)} 
                          type="button"
                          className="view-btn"
                        >
                          <Eye size={18} strokeWidth={1.5} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

             {totalPages > 1 && (
                          <Row className="justify-content-between align-items-center mt-4 px-2">
                            <Col xs={12}
                              lg={5} xl={6} className="text-secondary d-inline-flex align-items-center gap-2">
                              <FaInfoCircle className="text-blue" size={14} />
                              {t("showing")} {bookingsList.length} {t("of")} {total} {t("products")}
                            </Col>
                            <Col xs={12}
                              lg={7} xl={6} className="d-flex gap-2 justify-content-end mt-2">
                              <Pagination className="custom-pagination mb-0">
                                <Pagination.First
                                  onClick={() => handlePageChange(1)}
                                  disabled={currentPage === 1}
                                  className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                                >
                                  <FaChevronLeft size={12} />
                                  <FaChevronLeft size={12} className="ms-1" style={{ marginLeft: '-4px' }} />
                                </Pagination.First>
                                <Pagination.Prev
                                  onClick={() => handlePageChange(currentPage - 1)}
                                  disabled={currentPage === 1}
                                  className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                                >
                                  <FaChevronLeft size={12} />
                                </Pagination.Prev>
            
                                {Array.from(
                                  { length: Math.min(maxVisiblePages, totalPages) },
                                  (_, i) => {
                                    let pageNum;
            
                                    const half = Math.floor(maxVisiblePages / 2);
            
                                    if (totalPages <= maxVisiblePages) {
                                      // Total pages less than visible limit
                                      pageNum = i + 1;
                                    } else if (currentPage <= half + 1) {
                                      // Near the beginning
                                      pageNum = i + 1;
                                    } else if (currentPage >= totalPages - half) {
                                      // Near the end
                                      pageNum = totalPages - maxVisiblePages + i + 1;
                                    } else {
                                      // Middle range
                                      pageNum = currentPage - half + i;
                                    }
            
                                    return (
                                      <Pagination.Item
                                        key={pageNum}
                                        active={pageNum === currentPage}
                                        onClick={() => handlePageChange(pageNum)}
                                        className="border-0 rounded-3"
                                      >
                                        {pageNum}
                                      </Pagination.Item>
                                    );
                                  }
                                )}
                                <Pagination.Next
                                  onClick={() => handlePageChange(currentPage + 1)}
                                  disabled={currentPage === totalPages}
                                  className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                                >
                                  <FaChevronRight size={12} />
                                </Pagination.Next>
                                <Pagination.Last
                                  onClick={() => handlePageChange(totalPages)}
                                  disabled={currentPage === totalPages}
                                  className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                                >
                                  <FaChevronRight size={12} />
                                  <FaChevronRight size={12} className="ms-1" style={{ marginLeft: '-4px' }} />
                                </Pagination.Last>
                              </Pagination>
                            </Col>
                          </Row>
                        )}
          </>
        )}
      </div>

      <style jsx="true">{`
        .table-container {
          background: white;
          border-radius: 16px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
        }

        .booking-table {
          border-collapse: separate;
          border-spacing: 0;
          width: 100%;
          font-size: 0.95rem;
        }

        .booking-table thead th {
         
          background: var(--primary-blue);
          border-bottom: 2px solid #e2e8f0;
          padding: 18px 16px !important;
          font-weight: 600;
          color: white;
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
         
          white-space: nowrap;
        }

        .booking-table tbody tr {
          transition: all 0.2s ease;
          border-bottom: 1px solid #f1f5f9;
        }

        .booking-table tbody tr:hover {
          background-color: var(--secondary-blue) !important;
          cursor: pointer;
        }

        .booking-table td {
          padding: 16px !important;
          vertical-align: middle;
          color: #334155;
          border-bottom: 1px solid #f1f5f9;
          background: white;
          white-space: nowrap;
        }

        .booking-number {
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 500;
          color: #0f172a;
        }

        .service-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          background: var(--secondary-blue);
          border-radius: 10px;
          color: var(--primary-blue);
          font-size: 1rem;
          transition: all 0.2s ease;
        }

        .service-icon svg {
          width: 17px;
          height: 17px;
        }

        .booking-row:hover .service-icon {
          background: white;
          color: var(--primary-blue);
          transform: scale(1.05);
        }

        .status-badge {
          padding: 6px 16px;
          border-radius: 30px;
          font-size: 0.85rem;
          font-weight: 600;
          display: inline-block;
          text-transform: capitalize;
          letter-spacing: 0.3px;
          transition: all 0.2s ease;
        }

        .status-confirmed {
          background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
          color: #2563eb;
          border: 1px solid #bfdbfe;
        }

        .status-pending {
          background: linear-gradient(135deg, #fef3c7 0%, #fffbeb 100%);
          color: #d97706;
          border: 1px solid #fde68a;
        }

        .status-cancelled {
          background: linear-gradient(135deg, #fee2e2 0%, #fef2f2 100%);
          color: #dc2626;
          border: 1px solid #fecaca;
        }

        .status-completed {
          background: linear-gradient(135deg, #dcfce7 0%, #f0fdf4 100%);
          color: #16a34a;
          border: 1px solid #bbf7d0;
        }

        .price {
          font-weight: 700;
          color: #0f172a;
          font-size: 1.05rem;
        }

        .currency {
          color: #64748b;
          font-size: 0.85rem;
          background: #f1f5f9 !important;
          border: none;
        }

        .view-btn {
          background: transparent;
          border: none;
          padding: 10px;
          cursor: pointer;
          border-radius: 10px;
          transition: all 0.2s ease;
          color: #64748b;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
        }

        .view-btn:hover {
          background: var(--secondary-blue);
          color: var(--primary-blue);
          transform: scale(1.1);
        }

        .table-responsive {
          border-radius: 12px;
          scrollbar-width: thin;
          scrollbar-color: var(--primary-blue) #f1f5f9;
        }

        .table-responsive::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        .table-responsive::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 10px;
        }

        .table-responsive::-webkit-scrollbar-thumb {
          background: var(--primary-blue);
          border-radius: 10px;
          opacity: 0.5;
        }

        .table-responsive::-webkit-scrollbar-thumb:hover {
          background: var(--primary-blue);
        }

        .custom-pagination .page-item .page-link {
          border: none;
          margin: 0 4px;
          border-radius: 10px !important;
          color: var(--primary-blue);
          font-weight: 500;
          padding: 8px 14px;
          transition: all 0.2s ease;
          box-shadow: none;
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 40px;
          height: 40px;
        }

        .custom-pagination .page-item.active .page-link {
          background: var(--primary-blue);
          color: white;
          border-color: var(--primary-blue);
        }

        .custom-pagination .page-item .page-link:hover {
          background: var(--secondary-blue);
          color: var(--primary-blue);
          transform: translateY(-2px);
        }

        .custom-pagination .page-item.disabled .page-link {
          background: transparent;
          color: #ccc;
        }

        .bg-blue {
          background: var(--primary-blue) !important;
          transition: all 0.2s ease;
        }

        .bg-blue:hover {
          opacity: 0.9;
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(149, 73, 248, 0.25) !important;
        }

        .text-blue {
          color: var(--primary-blue) !important;
        }

        @media (max-width: 768px) {
          .booking-table td,
          .booking-table th {
            padding: 12px !important;
            font-size: 0.85rem;
          }
          
          .service-icon {
            width: 32px;
            height: 32px;
          }
          
          .status-badge {
            padding: 4px 12px;
            font-size: 0.75rem;
          }
        }
.table-responsive-custom {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
      `}</style>
    </>
  );
};

export default Home;